import * as React from "react";
function SvgChartUp(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth={2.5}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2 23.648l8.989-9.634 5.732 6.143L28.815 5.731" />
        <path d="M21.624 6.386l7.318-.773.77 7.354" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgChartUp);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
